import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import SearchPage from './SearchPage';

type TParams = { id: string, url: string }

function Search({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={SearchPage} />
            <Route exact path={`${match.url}/subscription`} component={SearchPage} />
            <Route exact path={`${match.url}/users`} component={SearchPage} />
            <Route exact path={`${match.url}/companies`} component={SearchPage} />
            <Route exact path={`${match.url}/demo`} component={SearchPage} />
            <Route exact path={`${match.url}/disabled`} component={SearchPage} />
            <Route exact path={`${match.url}/trial`} component={SearchPage} />
            <Route exact path={`${match.url}/delete`} component={SearchPage} />
            <Route exact path={`${match.url}/access`} component={SearchPage} />
            <Route exact path={`${match.url}/parentchild`} component={SearchPage} />
            <Route exact path={`${match.url}/feature`} component={SearchPage} />
        </Switch>
    );
}

export default Search;
